const axios = require("axios");

class Request {
  responseType = "json";
  response = null;

  constructor(baseURL) {
    this.baseURL = baseURL;
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  async #base(method, uri, payload) {
    try {
      const context = this.buildContext(method, uri, payload);

      this.response = await axios(context);
      if (this.responseType !== "json") {
        this.responseType = "json";
      }
      return {
        data: this.response.data,
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  buildContext(method, uri, payload) {
    const context = {};
    context.headers = this.headers;
    if (method === "GET") {
      context.params = payload;
    } else {
      context.data = payload;
    }
    context.method = method;
    context.url = uri;
    context.baseURL = this.baseURL;
    context.responseType = this.responseType;

    return context;
  }

  post(uri, payload) {
    return this.#base("POST", uri, payload);
  }

  get(uri, params = {}) {
    return this.#base("GET", uri, params);
  }

  put(uri, payload) {
    return this.#base("PUT", uri, payload);
  }

  patch(uri, payload) {
    return this.#base("PATCH", uri, payload);
  }
  delete(uri, params = {}) {
    return this.#base("DELETE", uri, params);
  }

  setHeader(key, value) {
    this.headers[key] = value;
  }

  setHeaders(headers) {
    this.headers = headers;
    return this;
  }

  withCredentials(bearer_token) {
    axios.default.withCredentials = true;
    this.setHeader("Authorization", bearer_token);
  }

  hasFiles() {
    this.setHeader("Content-Type", "multipart/form-data");
    return this;
  }

  blobResponse() {
    this.responseType = "blob";
  }

  getResponse() {
    return this.response;
  }
}

export default Request;
